import { MDBBtn, MDBCard, MDBCardBody, MDBCardHeader, MDBRow, MDBCol, MDBCardText, MDBCardTitle, MDBContainer, MDBCardSubTitle, MDBIcon } from "mdb-react-ui-kit";
// import React from "react";

export function ContactUsContent() {

    return (
        <>
            <MDBCard className={'border border-0 border-success shadow'}>
                <MDBCardHeader>CONTACT US</MDBCardHeader>
                <MDBCardBody className={'border border-0 border-danger'}>
                    <MDBRow className={'g-3'}>
                        <MDBCol lg={3} className={'border border-0 border-danger'}>
                            <MDBCard className={'shadow-0'}>
                                <MDBCardBody>
                                    <MDBCardSubTitle className={'mb-2'}>Phone Number</MDBCardSubTitle>
                                    <MDBCardText className={'fw-light'}>
                                        <p className={'lh-sm'}>
                                            <MDBIcon fas icon="phone" /> 0243522349<br />
                                        </p>
                                    </MDBCardText>
                                </MDBCardBody>
                            </MDBCard>
                        </MDBCol>
                        <MDBCol lg={3} className={'border border-0 border-danger'}>
                            <MDBCard className={'shadow-0'}>
                                <MDBCardBody>
                                    <MDBCardSubTitle className={'mb-2'}>Email</MDBCardSubTitle>
                                    <MDBCardText className={'fw-light'}>
                                        <p className={'lh-sm'}>
                                            <MDBIcon fas icon="envelope" /> nusnetwork@gmail.com<br />
                                            <MDBIcon fas icon="envelope" /> dnyadnu@gmail.com<br />
                                        </p>
                                    </MDBCardText>
                                </MDBCardBody>
                            </MDBCard>
                        </MDBCol>
                        <MDBCol lg={3} className={'border border-0 border-danger'}>
                            <MDBCard className={'shadow-0'}>
                                <MDBCardBody>
                                    <MDBCardSubTitle className={'mb-2'}>Address</MDBCardSubTitle>
                                    <MDBCardText className={'fw-light'}>
                                        <p className={'lh-sm'}>
                                            <MDBIcon fas icon="address-card" /> Post Office Box KF 797 <br /> Koforidua <br /> E/R, Ghana<br />
                                        </p>
                                    </MDBCardText>
                                </MDBCardBody>
                            </MDBCard>
                        </MDBCol>
                        <MDBCol lg={3} className={'border border-0 border-danger'}>
                            <MDBCard className={'shadow-0'}>
                                <MDBCardBody>
                                    <MDBCardSubTitle className={'mb-2'}>Social</MDBCardSubTitle>
                                    <MDBCardText className={'fw-light'}>
                                        <p className={'lh-sm'}>
                                            <div>
                                                <a href='https://www.facebook.com/share/16jbZWVmyT/' className='me-4 text-reset'>
                                                    <MDBIcon fab icon="facebook-f" />
                                                </a>
                                                {/* <a href='' className='me-4 text-reset'>
                                                    <MDBIcon fab icon="twitter" />
                                                </a>
                                                <a href='' className='me-4 text-reset'>
                                                    <MDBIcon fab icon="google" />
                                                </a>
                                                <a href='' className='me-4 text-reset'>
                                                    <MDBIcon fab icon="instagram" />
                                                </a>
                                                <a href='' className='me-4 text-reset'>
                                                    <MDBIcon fab icon="linkedin" />
                                                </a>
                                                <a href='' className='me-4 text-reset'>
                                                    <MDBIcon fab icon="github" />
                                                </a> */}
                                            </div>
                                        </p>
                                    </MDBCardText>
                                </MDBCardBody>
                            </MDBCard>
                        </MDBCol>
                    </MDBRow>
                </MDBCardBody>

                <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3967.5995328227855!2d-0.28380562501102813!3d6.049548993936236!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNsKwMDInNTguNCJOIDDCsDE2JzUyLjQiVw!5e0!3m2!1sen!2sgh!4v1767082424135!5m2!1sen!2sgh" height="450" style={{border:'0px'}} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
            </MDBCard>
        </>
    )
}